import {
  defaultSocialMediaLinks,
  SocialMediaLink,
} from './defaultSocialMediaLinks'

interface SocialIconsProps {
  fontSize?: number
  className?: string
  socialMediaLinks?: SocialMediaLink[]
}

const SocialMediaLinks = ({
  fontSize = 24,
  className = '',
  socialMediaLinks = defaultSocialMediaLinks,
}: SocialIconsProps) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {socialMediaLinks.map(({ href, Icon }, index) => (
        <a key={href} href={href} target='_blank' rel='noopener noreferrer'>
          <Icon fontSize={fontSize} />
        </a>
      ))}
    </div>
  )
}

export default SocialMediaLinks
